import * as React from 'react';
import * as classNames from 'classnames';

import './style.sass';

export interface IPopoverProps {
  className?: string;
  children?: any;
  message?: string;
  visible: boolean;
  isHint?: boolean;
  onHide?: () => void;
}

/**
 * @TODO
 *  Need to consider available Popover/Tooltip components,
 *  instead of write/support custom solution
 */
export const Popover: React.StatelessComponent<IPopoverProps> = ({
  className,
  children,
  visible,
  message,
  isHint,
  onHide,
}: IPopoverProps) => (
    <div onAnimationEnd={onHide} className={classNames(
      'popover-component',
      'popover-component_bottom',
      {
         'popover-component_hidden': !visible,
         'popover-component_hint': isHint,
      },
      className,
    )}>
      {message ? (
        <div className={'popover-component__message'}>{message}</div>
      ) : (
        children
      )}
    </div>
  );
